import { Pipe, PipeTransform } from '@angular/core';
import { QuestionTypeEnum } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { snakeCase } from 'lodash';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({ name: 'formQuestionType' })
export class FormQuestionTypePipe implements PipeTransform {
  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform (type: QuestionTypeEnum): string {
    if (!type) {
      return null;
    }

    const constraintCaseType = snakeCase(QuestionTypeEnum[type]).toUpperCase();
    return this.translateService.instant(`FORM_QUESTION_TYPE.${constraintCaseType}`);
  }
}
